// 行程
export const approval = [{
  path: '/trip/approval',
  name: 'approval',
  component: () => import('@/page/trip/approval/approval'),
  meta: {
    title: '行程审批'
  }
}

]
export const beforeList = [
  {
    path: '/beforeApprove',
    name: 'beforeApprove',
    component: () => import('@/page/applyOrder/beforeApprove'),
    meta: {
      title: '事前申请审批'
    }
  }
]
export const tripService = [
  {
    // 值机页面
    path: '/trip/zhiji',
    name: 'zhiji',
    component: () => import('@/page/trip/zhiji'),
    meta: {
      title: '值机选座'
    }
  },
  {
    // 航班动态
    path: '/trip/flightStatus',
    name: 'flightStatus',
    component: () => import('@/page/trip/flightStatus'),
    meta: {
      title: '航班动态'
    }
  }
]
export const tripchildren = [
  {
    path: '/trip/domesticair',
    name: 'domesticair',
    component: () => import('@/page/trip/domesticair/domesticair'),
    meta: {
      title: '国内机票行程',
      role: 'jpdd'
    }

  },
  {
    // 国内机票详情
    path: '/trip/details',
    name: 'ticketdetails',
    component: () => import('@/page/trip/details/details'),
    meta: {

    }

  },
  {
    // 国际列表
    path: '/trip/airinternational',
    name: 'airinternational',
    component: () => import('@/page/trip/airinternational/airinternational'),
    meta: {
      title: '国际机票行程',
      role: 'gjjpdd'
    }

  },
  {
    // 国际机票详情
    path: '/trip/airinternational/details',
    name: 'nationaldetails',
    component: () => import('@/page/trip/airinternational/detail/detail'),
    meta: {

    }

  },
  {
    // 国际改签详情
    path: '/trip/airinternational/changedetails',
    name: 'nationalchangedetails',
    component: () => import('@/page/trip/airinternational/detail/changeDetail'),
    meta: {

    }

  }, {
    path: '/approveDetail',
    name: 'approveDetail',
    component: () => import('@/page/applyOrder/approveDetail'),
    meta: {
    }

  },
  {
    // 国际改签信息填写
    path: '/trip/airinternational/changeorder',
    name: 'nationalchangeorder',
    component: () => import('@/page/trip/airinternational/changorder/changeorder'),
    meta: {

    }

  },
  {
    // 改签
    path: '/trip/changeorder',
    name: 'changeorder',
    meta: {

    },
    component: () => import('@/page/trip/changeorder/changeorder')
  },
  {
    // 退票
    path: '/trip/returnTicket',
    name: 'returnTicket',
    meta: {

    },
    component: () => import('@/page/trip/returnTicket/returnTicket')
  },
  {
    // 改签详情
    path: '/trip/changedetail',
    name: 'changedetail',
    meta: {

    },
    component: () => import('@/page/trip/changedetail/changedetail')
  },

  // ============================================================================================
  // 火车票
  {
    path: '/trip/trainjourney',
    name: 'trainjourney',
    component: () => import('@/page/trip/train/trainjourney'),
    meta: {
      title: '火车票行程',
      role: 'hcdd'
    }

  },

  {
    path: '/trip/traindetail',
    name: 'traindetail',
    component: () => import('@/page/trip/train/traindetail'),
    meta: {

    }

  },
  {
    path: '/trip/changetriandetail',
    name: 'changetriandetail',
    component: () => import('@/page/trip/train/changetriandetail'),
    meta: {

    }

  },
  {
    path: '/trip/changtrainorder',
    name: 'changtrainorder',
    component: () => import('@/page/trip/train/changtrainorder'),
    meta: {

    }

  },
  // ===============================================================================================
  // 酒店
  {
    path: '/trip/hoteljourney',
    name: 'hoteljourney',
    component: () => import('@/page/trip/hotel/hoteljourney'),
    meta: {
      title: '酒店行程',
      role: 'jddd'
    }

  },
  {
    path: '/trip/hoteldetail',
    name: 'hoteldetail',
    component: () => import('@/page/trip/hotel/detail/hoteldetail'),
    meta: {

    }
  },
  {
    path: '/trip/pay',
    name: 'hotelpay',
    component: () => import('@/page/trip/pay/orderpay'),
    meta: {

    }
  }

]

const tripRouter = [{
  // 个人中心
  path: '/trip',
  name: 'trip',
  redirect: '/trip/approval',
  meta: {

  },
  component: () => import('@/page/trip/trip'),
  children: approval.concat(tripchildren).concat(beforeList).concat(tripService)
}]

export default tripRouter



// WEBPACK FOOTER //
// ./src/router/modules/trip.js